/**
 * Mô hình hóa các tính năng tương tác (Context Menu) có thể áp dụng
 * trên từng mục của Danh sách Hội thoại (Cột List bên trái).
 * (Thoát khỏi cảnh gọi thẳng hàm onPinToggle(), onMute() lằng nhằng trên view html cũ)
 */
export enum EConversationAction {
  SELECT = 'SELECT', // Chọn hội thoại để hiển thị nội dung chat
  PIN = 'PIN', // Ghim hội thoại lên đầu danh sách
  UNPIN = 'UNPIN', // Bỏ ghim hội thoại

  MARK_UNREAD = 'MARK_UNREAD', // Đánh dấu chưa đọc (Cho thẻ hiển thị màu cam)

  MUTE = 'MUTE', // Hẹn giờ tắt chuông thông báo (1H, 4H, Tới 8h sáng)
  UNMUTE = 'UNMUTE', // Bật lại chuông thông báo tự do

  CREATE_REMINDER = 'CREATE_REMINDER', // Bật Popup Tạo nhắc hẹn (Hẹn gọi lại khách)

  ASSIGN_STAFF = 'ASSIGN_STAFF', // Trỏ hội thoại sang nhân viên khác (Chia Box)

  BLOCK_SPAM = 'BLOCK_SPAM', // Báo cáo Khách Spam / Chặn Message từ UID

  MANUAL_MERGE = 'MANUAL_MERGE', // Giao diện ép Gộp 2 hội thoại làm 1 thủ công

  SHARE = 'SHARE' // Copy Link chat nội bộ gửi cho nhân viên khác tiếp ứng
}

/**
 * Kiện hàng Payload chứa mệnh lệnh gửi từ Dummy UI List Item
 * Cột trái búng Event List sang Phải cho Smart Component tổng đón nhận
 */
export interface IConversationActionEvent {
  action: EConversationAction;
  conversationId: string;
  payload?: any; // Dữ liệu mở rộng (Ví dụ: Số phút Mute, ID nhân viên nhận)
}
